import styled from 'styled-components';
import { colors } from '@/template/styles';

export const Container = styled.div`
    position: relative;
`;

export const Label = styled.div`
    position: absolute;
    left: 10px;
    background: #fff;
    top: -9px;
    padding: 0px 10px;
    z-index: 5;
    color: ${(props) => {
      if (props.status === 'danger') {
        return `${colors.danger} !important`;
      }
      return '#000';
    }};
`;

export const Feedback = styled.div`
    color: ${colors.danger};
    font-size: 12px;
    margin-top: 5px;
    margin-left: 10px;
`;
